export default __webpack_public_path__ + "30e1215e2feb5d95de05cc52ce48f0f0.png";